import * as CONST from '../common/const';
import api from 'utils/api';
import { logger } from '@amzn/awsui-components-react/polaris/internal/core/runtime/src';

export const downloadSourceRequest = () => {
  return {
    type: CONST.DOWNLOAD_SOURCE_REQUEST
  }
}

export const downloadSourceSuccess = (downloadUrl) => {
  return {
    type: CONST.DOWNLOAD_SOURCE_SUCCESS,
    downloadUrl: downloadUrl
  }
}

export const downloadSourceFailure = (error) => {
  return {
    type: CONST.DOWNLOAD_SOURCE_FAILURE,
    downloadError: error,
  };
};


export const downloadSource = payload => async (dispatch, getState) => {

  dispatch(downloadSourceRequest());
  try {
    const result = await api.downloadSourceData(payload);

    dispatch(downloadSourceSuccess(result.downloadUrl));
  } catch (e) {
    dispatch(downloadSourceFailure(e));
  }
};